export default "__VITE_ASSET__c9joTLhY__"